import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './global-components/navbar-v2';
import BlocActualite from './global-components/bloc-actualite';
import Footer from './global-components/footer-v2';
import Scrollp from './Scroll-Parallax/scrollp';
import FormulaireInscriptionEnLigne from './global-components/formulaire-inscritenligne'; // Import du formulaire
import Page_header_news from './global-components/page-header-news';
const Actualites = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [isPopupVisible, setIsPopupVisible] = useState(false); // État pour afficher ou masquer le popup

  const handleOpenPopup = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div>
      <Navbar />
      <Page_header_news headertitle="Actualités" />
      <BlocActualite />
      <Footer />
      <Scrollp />

      {/* Boutons fixes */}
      <div className="fixed-buttons">
        <Link to="/Formateur">
          <button className="btn btn-primary">Devenir formateur</button>
        </Link>

        <Link to="/inscriptionenligne">
          <button className="btn btn-secondary">Inscription en ligne</button>
        </Link>
      </div>

      {/* Popup */}
      {isPopupVisible && (
        <div className="popup-overlay ">
          <div className="popup-content ">
            {/* Formulaire d&apos;inscription */}
            <FormulaireInscriptionEnLigne />
            <button onClick={handleClosePopup} className="popup-close-button">
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Actualites;
